// Os controles da lista de clientes: a busca, os recortes e a ordem. (#880)

import { type ReactNode } from 'react';
import { type ClienteDaLista } from '@cliqcrm/contracts';
import { Botao, Icone, MenuAcoes } from '@/shared/ui';
import { type AcoesDaLinha } from './acoes-da-linha';

/** Os dois controles da linha, iguais na tabela e na lista. */
export function Controles({
  cliente,
  acoes,
}: {
  cliente: ClienteDaLista;
  acoes: AcoesDaLinha;
}): ReactNode {
  return (
    <span className="clientes__acoes">
      {/*
        Abrir a conversa fica VISÍVEL porque é o que se faz em nove de cada dez
        vezes. Sem conversa ele não some: sumir faria a coluna dançar linha a
        linha, e o motivo escrito ensina de onde vem uma conversa.
      */}
      <Botao
        variante="fantasma"
        icone
        miudo
        rotulo={`Abrir a conversa de ${cliente.nome_exibicao ?? 'contato sem nome'}`}
        desabilitado={!cliente.conversa_id}
        motivo="Este cliente ainda não falou por nenhum canal."
        onClick={() => acoes.abrirConversa(cliente)}
      >
        <Icone nome="atendimento" />
      </Botao>
      <MenuAcoes
        rotulo={`Mais ações de ${cliente.nome_exibicao ?? 'contato sem nome'}`}
        itens={[
          { rotulo: 'Ver a ficha completa', aoClicar: () => acoes.abrirFicha(cliente) },
          { rotulo: 'Criar tarefa de retomada', aoClicar: () => acoes.criarTarefa(cliente) },
          {
            /*
              O rótulo diz o que sai, e não "mandar mensagem": o que sai é um
              modelo aprovado, e a pessoa precisa saber disso antes de abrir.
            */
            rotulo: 'Iniciar atendimento por modelo',
            aoClicar: () => acoes.iniciarAtendimento(cliente),
            ...(cliente.telefone
              ? {}
              : {
                  desabilitado: true,
                  motivo:
                    'Sem telefone cadastrado não há para onde mandar. Edite a ficha do ' +
                    'cliente primeiro.',
                }),
          },
          {
            rotulo: 'Passar para outra pessoa',
            aoClicar: () => acoes.passar(cliente),
            // Sem conversa não há o que passar: cliente não tem dono, e o que
            // muda de mão é a conversa (com a oportunidade junto).
            ...(cliente.conversa_id
              ? {}
              : {
                  desabilitado: true,
                  motivo:
                    'Este cliente ainda não falou por nenhum canal, e é a conversa que muda ' +
                    'de dono — o cliente é da organização.',
                }),
          },
        ]}
      />
    </span>
  );
}
